import React, { useState } from 'react';
import { FaRulerCombined, FaProjectDiagram, FaPencilRuler, FaHammer, FaUsers } from 'react-icons/fa'; // Updated icons
import "./whychose.css";
import Contactpopup from '../contact_popup/contactpopup';

function WhyChoose() {
     const [showpopup, setShowpopup] = useState(false);
    
      const openPopup = () => {
        setShowpopup(true);
      }
    
      const closePopup = () => {
        setShowpopup(false);
      }
    
    return (
        <>
        <section className="section whyInterior bgGray">
            <div className="container why-container">
                <div>
                    <h2 className="heading-head">Why Choose Us</h2>
                    <p className="subHeading-para">
                        We go beyond design—we create experiences.
                    </p>
                </div>

                <div className="whyChooseus_whyInteriorBox__4NFp7 displayGrid grid5">
                    <div className="whyChooseus_whyItem__oCHhb plr">
                        <figure>
                            <FaRulerCombined size={30} color="#cf5b55" /> {/* Interior Excellence */}
                        </figure>
                        <h4 className="sub-heading-h4">Interior Excellence</h4>
                        <p className="subHeading-para">32+ turnkey projects across commercial, residential, and industrial sectors.</p>
                    </div>

                    <div className="whyChooseus_whyItem__oCHhb plr">
                        <figure>
                            <FaProjectDiagram size={30} color="#cf5b55" /> {/* Project Management */}
                        </figure>
                        <h4 className="sub-heading-h4">End-to-End Project Management</h4>
                        <p className="subHeading-para">From planning to execution, we ensure seamless delivery.</p>
                    </div>

                    <div className="whyChooseus_whyItem__oCHhb plr">
                        <figure>
                            <FaPencilRuler size={30} color="#cf5b55" /> {/* Bespoke Design */}
                        </figure>
                        <h4 className="sub-heading-h4">Bespoke Design</h4>
                        <p className="subHeading-para">Tailored interiors to match your vision and business needs.</p>
                    </div>

                    <div className="whyChooseus_whyItem__oCHhb plr">
                        <figure>
                            <FaHammer size={30} color="#cf5b55" /> {/* Craftsmanship */}
                        </figure>
                        <h4 className="sub-heading-h4">Superior Craftsmanship</h4>
                        <p className="subHeading-para">Premium materials and expert execution for lasting quality.</p>
                    </div>

                    <div className="whyChooseus_whyItem__oCHhb plr">
                        <figure>
                            <FaUsers size={30} color="#cf5b55" /> {/* Client-Centric Approach */}
                        </figure>
                        <h4 className="sub-heading-h4">Client-Centric Approach</h4>
                        <p className="subHeading-para">Transparent pricing, clear communication, and on-time completion.</p>
                    </div>
                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", }}>
                    <button className="whyChooseus_whyChooseBtn__GTv3X btn btnPrimery mxAuto main-enquiry-button"
                        style={{ background: "#e6c6c0", fontWeight: 500, color:"#cf5b55" }} onClick={openPopup} >
                        Book Free Consultation
                    </button>
                </div>
            </div>
        </section>
          { showpopup && <Contactpopup onClose={closePopup} /> }
          </>
    );
}

export default WhyChoose;
